module.exports = __webpack_public_path__ + "static/img/waqa-michael.43bad53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/waqa-michael.jpg
// module id = XaoK
// module chunks = 0